export type ToastLabAction = 'error' | 'success' | 'warning' | 'info' | 'attention';

export const TOAST_LAB_DEFAULT_DURATION_MS = 60_000;

export type ToastLabPresetId = 'short' | 'overflow' | 'unbreakable' | 'cta';

export type ToastLabPreset = {
  message: string;
  title: string;
  action: ToastLabAction;
};

export const TOAST_LAB_PRESETS: Record<ToastLabPresetId, ToastLabPreset> = {
  short: {
    message: 'Saved.',
    title: '',
    action: 'success',
  },
  overflow: {
    message:
      'The server returned a validation error describing multiple conflicting field constraints that must be resolved before your submission can be saved to the course module record.',
    title: 'Could not save',
    action: 'error',
  },
  unbreakable: {
    message: `${'W'.repeat(80)}${'0'.repeat(80)}`,
    title: 'Unbreakable token',
    action: 'error',
  },
  cta: {
    message: 'Hermione is in My connections',
    title: '',
    action: 'success',
  },
};

export function isToastLabPresetId(value: string | null | undefined): value is ToastLabPresetId {
  return value === 'short' || value === 'overflow' || value === 'unbreakable' || value === 'cta';
}

export function parseToastLabAction(value: string | null | undefined): ToastLabAction | undefined {
  if (
    value === 'error'
    || value === 'success'
    || value === 'warning'
    || value === 'info'
    || value === 'attention'
  ) {
    return value;
  }
  return undefined;
}
